
const baseUserlUrl = "User"
const baseAccountUrl = "Account"
  const endpoints = {
   userInfo:`${baseUserlUrl}/GetUserInfo`,
   uploadProfileImage:`${baseUserlUrl}/AddImageByUser`,
   updateUserPhoneNumber:`${baseUserlUrl}/UpdateUserPhoneAfterVerify`,
   updateProfileInfoes:`${baseUserlUrl}/UpdateUserInfo`,
   deleteProfileImage:`${baseUserlUrl}/UploadProfileImage`,
   getUserPermissions:`${baseUserlUrl}/GetUserPermission`,
   getUserPackage:`${baseUserlUrl}/GetUserPackage`,
   getUserDopings:`${baseUserlUrl}/GetUserDopings`,
   updatePermissions:`${baseUserlUrl}/UpdatePermission`,
   changePassword:`${baseAccountUrl}/ChangePassword`,
   deleteAccount:`${baseAccountUrl}`,
  
  };
  
  export default endpoints;